import {
  useEditProfileSectionQuery,
  useSaveAdminProfileMutation
} from 'generated/graphql';
import {
  formUtil,
  useLoading,
  validationUtil
} from 'modules';
import * as yup from 'yup';



const __formSchema = yup
  .object({
    firstName: validationUtil.nonEmptyStringSchema.required('First name is required.'),
    lastName: validationUtil.nonEmptyStringSchema.required('Last name is required.'),
    email: validationUtil.emailSchema.required('Email is required.')
  })
  .required();


export type IFormState = yup.InferType<typeof __formSchema>;



export function useEditProfileSection() {
  const tuple = useEditProfileSectionQuery();
  const [saveAdminProfile, saveAdminProfileTuple] = __useSaveAdminProfileMutation(tuple.data?.loggedInUser?.id ?? '');
  const loading = useLoading([tuple, saveAdminProfileTuple]);

  const form = formUtil.useRemoteData2FormState_experimental({
    tuple: tuple as any,
    schema: __formSchema,
    fnGqlData2FormState: (gqlData: any) => {
      const loggedInUser = gqlData?.loggedInUser;
      return {
        firstName: loggedInUser?.firstName ?? '',
        lastName: loggedInUser?.lastName ?? '',
        email: loggedInUser?.email ?? ''
      };
    }
  });

  return {
    loading,
    form,
    mutations: { saveAdminProfile }
  };
}



function __useSaveAdminProfileMutation(userId: string) {
  const [fnMutate, tuple] = useSaveAdminProfileMutation();

  async function fnWrappedMutate(formData: IFormState) {
    await fnMutate({
      variables: {
        input: {
          id: userId,
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName
        }
      }
    });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
